import { Modal } from "react-bootstrap";
import { useState } from "react";
import { shareCode } from "../../actions/publishAction";
import { DeleteKeys } from "../../actions/appsMoreAction";
import { TOAST_ERROR, TOAST_SUCCESS } from "../../utils";
import { emailValidation } from "../../utils";

const SendCodeByEmail = ({setOpenPopup, sharecode }) => {

  const htmlCode = !sharecode ? "" : (sharecode.emailCmp ? sharecode.emailCmp : (sharecode.code == 'lite_code' ? sharecode.liteCode : sharecode.iframe))
  const [email, setEmail] = useState('');
  const [loader, setLoader] = useState(false);

  const sendCode = () => {

  if (email.trim().length > 0) {

    const code = {
      'email': email,
      'type': sharecode.getPage,
      'htmlCode': htmlCode
    }
 
    if(emailValidation(email)){
      setLoader(true);
      shareCode(code).then((res) => {

      if (res.data.status) {
         setTimeout(() => {
          DeleteKeys();
          TOAST_SUCCESS(!sharecode ? 'Email Campaign Code successfully shared.' : 'Wall URL successfully shared.')
          setLoader(false)
          setOpenPopup(false)
        }, 1000);
      }else{
        TOAST_ERROR(res.data.message);
        setLoader(false)
      }
    })
  }else{
    TOAST_ERROR('Invalid email format!!');
  }
  } else
    TOAST_ERROR('Please fill mail Id');
  }

  return (
    <>
      <Modal dialogClassName=" modal-dialog modal-dialog-centered modal-md personalizePopupModal dynamic-popup"
        size="lg" show={true}>
        <Modal.Body>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="modal"
            onClick={(e) => {setOpenPopup(false) }}
          >
          </button>
          <div className="p-8">
            <div className="pt-4 text-center">
            </div> <div className="mb-7 text-center">
              <h2 className="font-weight-boldest font-size-h2 mb-3">Send code by email </h2>
              <p className="font-size-lg">Share this embed code with your team. Enter the email Id to send the code directly to them</p>
            </div>
            <div className="from-group">
              <textarea name="data[Wall][emails]" placeholder="Ex: support@socialwalls.com,info@taggbox.com" label="Emails" className="form-control form-control-lg" value={email} onChange={(e) => setEmail(e.target.value)} id="wallemails" style={{ height: '78px' }}></textarea> <span id="wallemailserror" className="errorMessage required">
              </span>
              
              <button type="submit" onClick={(e) => sendCode(e)} className={`${loader ? 'ladda-button spinner spinner-white spinner-right disabled ' : ''} btn btn-primary btn-lg w-100 mt-5`}  disabled={loader} data-factors-bind="true" data-factors-click-bind="true">Share Code</button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default SendCodeByEmail
